import { useTrackers } from '@ps/web-shared-analytics';
import { Translation } from '@ps/web-shared-components';
import React, { useCallback } from 'react';

import QuestionIcon from '../../../../assets/icons/question.svg';
import IconLegend from '../../../IconLegend/IconLegend';
import Tooltip from '../../../Tooltip/Tooltip';

import { TXTCLI_Game } from './TableHeadGame.messages.json';
import styles from './TableHeadGame.scss';

const TableHeadGame: React.FC = () => {
  const { panelToggled } = useTrackers();
  const handleInfoMouseEnter = useCallback(
    () => panelToggled({ panelName: 'Icon Legend', isOpen: true }),
    [panelToggled]
  );

  return (
    <div className={styles.container}>
      <Translation {...TXTCLI_Game} />

      <div title="" onClick={(e) => e.stopPropagation()} onMouseEnter={handleInfoMouseEnter}>
        <Tooltip
          content={<IconLegend />}
          placement="bottom"
          arrowClassName={styles.tooltipArrow}
          tooltipClassName={styles.tooltip}
          refElementClassName={styles.tooltipWrapper}
        >
          <QuestionIcon />
        </Tooltip>
      </div>
    </div>
  );
};

export default TableHeadGame;
